<template>
  <draggable-container>
    <div class="modal-content">
      <button
        class="calculator-close-button"
        @click.stop="$emit('close')"
        @mousedown.stop
      >
        <icon
          name="cross"
          class="calculator-close-icon"
        >
        </icon>
      </button>
      <calculator-engine></calculator-engine>
    </div>
  </draggable-container>
</template>

<script>
import CalculatorEngine from '@/components/calculator/CalculatorEngine.vue';
import DraggableContainer from './DraggableContainer.vue';
import Icon from '@components/singletons/icon.vue';

export default {
  components: {
    CalculatorEngine,
    DraggableContainer,
    Icon,
  },
  emits: ['close'],
};
</script>

<style lang="scss" scoped>
.modal-content {
  position: relative;
  background: white;
  border: 1px solid black;
  border-radius: 0.25rem;
  box-shadow: 0 0 0.5rem 0.5rem rgba(0, 0, 0, 0.1);
}

.calculator-close-button {
  position: absolute;
  top: -1rem;
  right: -1rem;
  height: 1.5rem;
  width: 1.5rem;
  background: white;
  border: 1px solid black;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
}

.calculator-close-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

</style>
